const configContent = {
    content: {
        listLayout: 'ContentListDefaultLayout',
        filterLayout: 'ContentFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            opp: 1,
            cid: 30,
            ct : 'basic',
        },
        getFunc: 'getContent',
        listApiParamSet: {
            type: 'content',
            ip: 1,
            cty : 'basic',
        },

        deleteFunc: 'deleteContent',
        deleteApiParamsSet: {type: 'content'},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "삭제된 콘텐츠 입니다.",
        },
        keyName: 'c_idx',
    },
    regular: {
        listLayout: 'ContentListRegularLayout',
        filterLayout: 'ContentFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            ct: 'regular',
            opp: 1,
            cid: 30,
        },
        getFunc: 'getContent',
        listApiParamSet: {
            type: 'content',
            cty:'regular',
            ip: 1,
        },

        deleteFunc: 'deleteContent',
        deleteApiParamsSet: {type: 'content'},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "삭제된 콘텐츠 입니다.",
        },
        keyName: 'c_idx',
    },
    create: {
        writeLayouts: ['ContentWriteDefaultLayout'],
        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            opp: 1,
            cid: 30,
            ct : 'basic',
        },
        getFunc: 'getContent',
        detailApiParamsSet: {type: 'content',},
        getDetailParamsKey: 'id',
        writeFunc: 'createContent',
        writeApiParamSet: {
            type: 'content',
        },
        parsingData: {
            category: 'node_id',
            language: 'c_id',
            title: 'c_title',
            explain: 'c_content',
            type: 'c_type',
        },
        directUrl: '/content/content/',
        directType: 'detail',
        fileType: 'c-content',
        writeSuccessType: 1,
        writeFailTypes: {
            '-3': "선택하신 카테고리는 삭제된 카테고리입니다.",
            '-300': "제목이 중복되었습니다.",
            '-403': "권한이 없습니다.",
        },
        keyName: 'c_idx',
    },
    regularCreate: {
        writeLayouts: ['ContentWriteRegularLayout'],
        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            ct:'regular',
            opp: 1,
            cid: 30,
        },
        // getFunc: 'getContent',
        // detailApiParamsSet: {type: 'content',},
        // getDetailParamsKey: 'id',
        writeFunc: 'createContent',
        writeApiParamSet: {
            type: 'content',
        },
        parsingData: {
            category: 'node_id',
            language: 'c_id',
            title: 'c_title',
            explain: 'c_content',
            type: 'c_type',
            sIdx:'s_idx',
        },
        directUrl: '/streamingmanage/regularcontent/',
        directType: 'detail',
        fileType: 'c-content',
        writeSuccessType: 1,
        writeFailTypes: {
            '-3': "선택하신 카테고리는 삭제된 카테고리입니다.",
            '-300': "제목이 중복되었습니다.",
            '-403': "권한이 없습니다.",
        },
        keyName: 'c_idx',
    },
    update: {
        writeLayouts: ['ContentWriteDefaultLayout'],
        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            opp: 1,
            cid: 30,
            ct : 'basic',
        },
        getFunc: 'getContent',
        detailApiParamsSet: {type: 'content',},
        getDetailParamsKey: 'id',
        writeFunc: 'updateContent',
        writeApiParamSet: {
            type: 'content',
        },
        parsingData: {
            category: 'node_id',
            language: 'c_id',
            title: 'c_title',
            explain: 'c_content',
        },
        directUrl: '',
        directType: '',
        fileType: 'c-content',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': "삭제된 콘텐츠 입니다.",
            '-3': "선택하신 카테고리는 삭제된 카테고리입니다.",
            '-300': "제목이 중복되었습니다.",
            '-403': "권한이 없습니다.",
        },
        keyName: 'c_idx',
    },
    regularUpdate: {
        writeLayouts: ['ContentWriteRegularLayout'],
        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            ct:'regular',
            opp: 1,
            cid: 30,
        },
        getFunc: 'getContent',
        detailApiParamsSet: {type: 'content',},
        getDetailParamsKey: 'id',
        writeFunc: 'updateContent',
        writeApiParamSet: {
            type: 'content',
        },
        parsingData: {
            category: 'node_id',
            language: 'c_id',
            title: 'c_title',
            explain: 'c_content',
            type: 'c_type',
            sIdx:'s_idx',
        },
        directUrl: '',
        directType: 'back',
        fileType: 'c-content',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': "삭제된 콘텐츠 입니다.",
            '-3': "선택하신 카테고리는 삭제된 카테고리입니다.",
            '-300': "제목이 중복되었습니다.",
            '-403': "권한이 없습니다.",
        },
        keyName: 'c_idx',
    },
    user: {
        listLayout: 'ContentListDefaultLayout',
        filterLayout: 'ContentFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: '',
        listApiParamSet: {

        },
    },
    comment: {
        listLayout: 'ContentCommentListDefaultLayout',
        filterLayout: 'ContentCommentFilterDefaultLayout',
        paginationLayout: 'PaginationNoDeleteLayout',

        getCategoryFunc: 'getCategory',
        categoryApiParamsSet: {
            type: 'all',
            opp: 1,
            cid: 30,
            ct : 'basic',
        },
        getFunc: 'getContentComment',
        listApiParamSet: {
            re:1,
            ip: 1,
            cty : 'basic',
        },
    },
    commentUpdate: {
        writeLayouts: ['ContentWriteCommentLayout'],
        getFunc: 'getContent',
        detailApiParamsSet: {re: 1,},
        getDetailParamsKey: 'cid',
        writeFunc: 'updateContent',
        writeApiParamSet: {
            type: 'content',
        },
        parsingData: {
            category: 'node_id',
            language: 'c_id',
            title: 'c_title',
            explain: 'c_content',
        },
        directUrl: '',
        directType: '',
        fileType: 'c-content',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': "삭제된 콘텐츠 입니다.",
            '-3': "선택하신 카테고리는 삭제된 카테고리입니다.",
            '-300': "제목이 중복되었습니다.",
            '-403': "권한이 없습니다.",
        },
        keyName: 'c_idx',
    },
    commentDetail: {
        detailLayout: 'ContentCommentDetailLayout',
        getFunc: 'getContentComment',
        detailApiParamsSet: {
            ip:0,
            re:1
        },
        getDetailParamsKey: 'id',
        writeFunc: 'createContentComment',
        writeApiParamSet: {
            cc_type: 'reply',
        },
        updateFunc:'updateContentComment',
        parsingData: {
            content: 'cc_content',
        },
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {
        },
    },
    categoryBasic : {
        categoryApiParamsSet: {
            type : 'all',
            ct: 'basic',
            cid: 30,
            opp: 1,
            opf: 1,
        },
        getFunc : "getCategory",
        // listApiParamSet: {
        //     ct: 'basic',
        // },
        writeFunc : "updateCategory",
        createFunc : "createCategory",
        deleteFailTypes: {
            '-5': '카테고리 정보가 없습니다.',
            '-6': '삭제가 불가능한 카테고리입니다.',
            '-403': '권한이 없습니다.'
        },
        keyName: 'node_id',
        ctType : 'basic'
    },
    categoryRegular: {
        categoryApiParamsSet: {
            type:'all',
            ct: 'regular',
            cid: 30,
            opp: 1,
            opf: 1,
        },
        getFunc : "getCategory",
        listApiParamSet: {
            ct: 'regular',
        },
        writeFunc : "updateCategory",
        createFunc : "createCategory",
        deleteFailTypes: {
            '-5': '카테고리 정보가 없습니다.',
            '-6': '삭제가 불가능한 카테고리입니다.',
            '-403': '권한이 없습니다.'
        },
        keyName: 'node_id',
        ctType : 'regular'
    },
}

export default {
    methods: {
        returnContentConfig(type) {
            return configContent[type];
        }
    },
    filterConfig: {
        cr: { //작성일
            type: 'between',
            classname: 'filterDate'
        },
        sl: { //작성일
            type: 'between',
            classname: 'filterStreamingDate'
        },
        cid: {
            type: 'match',
            classname: 'filterCountry',
        },
        ti: { //제목
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput'
        },
        ni: {
            type: 'query',
            classname: 'searchInput'
        },
        pid: {
            type: 'match',
            classname: 'filterCate1'
        },
        nid: { //카테고리 2Depth
            type: 'match',
            classname: 'filterCate2'
        },
        id: {
            type: 'match',
            classname : 'filterId'
        }
    }
}
